export default "__VITE_ASSET__CaLP12Hy__"